// 之前在 formatBrushManager 中定义的 TEXT 常亮
export const FORMAT_BRUSH_TEXT = 'text';
